export default __webpack_public_path__ + "static/p4-b51352e4fe1a921bd3b69ba24ff93247.png";